import React, { useEffect, useState } from 'react';

const NoSSR = ({ children }) => {
    const [isBrowser, setIsBrowser] = useState(false);

    useEffect(() => {
        setIsBrowser(true);
    }, []);

    return isBrowser ? children : <></>;
};

export default NoSSR;
